var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isValueEmpty)?_c('span',{class:{'text-success': _vm.value > 0}},[_vm._v(_vm._s(_vm.str)+_vm._s(_vm.afterText))]):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }